import { useCallback } from 'react';

import { PDP_LIST_ID, PDP_LIST_NAME } from '~/features/tracking/constants';
import { useProductClickTracking } from '~/features/tracking/hooks/useProductClickTracking';
import { IVariation } from '~/lib/data-contract';

import styles from './productPickerGridItem.module.css';

import { ProductPickerImage } from '../ProductPickerImage/ProductPickerImage';
import { ProductPickerItem } from '../ProductPickerItem/ProductPickerItem';
import { ProductPickerLabel } from '../ProductPickerLabel/ProductPickerLabel';

export type ProductPickerGridItemProps = {
	variant: IVariation;
	onVariationClick: (variant: IVariation) => void;
	setOpen: (open: boolean) => void;
	type: string;
};

export const ProductPickerGridItem = ({ variant, onVariationClick, setOpen, type }: ProductPickerGridItemProps) => {
	const trackProductClick = useProductClickTracking(variant, {
		listName: PDP_LIST_NAME,
		listId: PDP_LIST_ID,
	});

	const handleClick = useCallback(() => {
		trackProductClick();
		onVariationClick(variant);
		setOpen(false);
	}, [onVariationClick, setOpen, trackProductClick]);

	if (type !== 'color') {
		return (
			<ProductPickerItem onClick={handleClick}>
				<ProductPickerLabel>{variant.sizeAttribute}</ProductPickerLabel>
			</ProductPickerItem>
		);
	}

	return (
		<li>
			<ProductPickerItem onClick={handleClick}>
				<ProductPickerImage image={variant.image} />
			</ProductPickerItem>
			{variant.color?.colorName ? <span className={styles.label}>{variant.color?.colorName}</span> : null}
		</li>
	);
};
